import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiEye, FiEyeOff } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const LoginPage: React.FC = () => {
  const { login, isLoading } = useAuth();
  const { t } = useTranslation();

  const safeT = (key: string, fallback: string) => {
    const v = t(key);
    return v === key ? fallback : v;
  };

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await login(email, password);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f4f6f8', fontFamily: "'Inter', sans-serif" }}>
      <div style={{ background: 'white', padding: '50px 40px', borderRadius: '20px', boxShadow: '0 10px 40px rgba(0,0,0,0.08)', width: '100%', maxWidth: '420px', textAlign: 'center' }}>
        <div style={{ marginBottom: '30px' }}>
          <img src="/Profunding_Azul.png" alt="ProFunding" style={{ maxWidth: '220px', height: 'auto', display: 'block', margin: '0 auto' }} />
        </div>

        <h1 style={{ fontSize: '1.8rem', color: '#333', margin: '0 0 10px 0', fontWeight: 800 }}>
          {safeT('login.title', 'Iniciar sesión')}
        </h1>

        <p style={{ color: '#666', marginBottom: '30px' }}>
          {safeT('login.subtitle', 'Accede con tu correo y contraseña')}
        </p>

        <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600, color: '#444', fontSize: '0.9rem' }}>
              {safeT('login.email_label', 'Correo')}
            </label>

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={safeT('login.email_placeholder', 'nombre@empresa.com')}
              required
              style={{ width: '100%', padding: '14px', borderRadius: '10px', border: '1px solid #e0e0e0', fontSize: '1rem', backgroundColor: '#f9f9f9' }}
            />
          </div>

          <div style={{ marginBottom: '30px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <label style={{ fontWeight: 600, color: '#444', fontSize: '0.9rem' }}>
                {safeT('login.password_label', 'Contraseña')}
              </label>

              <Link to="/recuperar-contrasena" style={{ fontSize: '0.85rem', color: '#673ab7', textDecoration: 'none', fontWeight: 600 }}>
                {safeT('login.forgot_password', '¿Olvidaste tu contraseña?')}
              </Link>
            </div>

            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={safeT('login.password_placeholder', 'Tu contraseña')}
                required
                style={{ width: '100%', padding: '14px 46px 14px 14px', borderRadius: '10px', border: '1px solid #e0e0e0', fontSize: '1rem', backgroundColor: '#f9f9f9' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? safeT('login.hide_password', 'Ocultar contraseña') : safeT('login.show_password', 'Ver contraseña')}
                title={showPassword ? safeT('login.hide_password', 'Ocultar contraseña') : safeT('login.show_password', 'Ver contraseña')}
                style={{
                  position: 'absolute',
                  right: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  color: '#673ab7',
                  padding: 4
                }}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '15px',
              background: 'linear-gradient(135deg, #673ab7 0%, #512da8 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: '1rem',
              fontWeight: 700,
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.8 : 1,
              boxShadow: '0 4px 15px rgba(103, 58, 183, 0.3)'
            }}
          >
            {isLoading ? safeT('login.loading', 'Cargando...') : safeT('login.submit', 'Entrar')}
          </button>
        </form>

        <div style={{ marginTop: 14, fontSize: '0.95rem' }}>
          <span style={{ color: '#666' }}>{safeT('register.no_account', '¿No tienes cuenta?')}</span>{' '}
          <Link to="/registro" style={{ color: '#673ab7', textDecoration: 'none', fontWeight: 800 }}>
            {safeT('register.create_account', 'Crea una aquí')}
          </Link>
        </div>

        <div style={{ marginTop: '24px', fontSize: '0.9rem' }}>
          <Link to="/" style={{ color: 'var(--color-texto-secundario)', textDecoration: 'none', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
            <FiArrowLeft /> {safeT('public.back_to_home', 'Volver al inicio')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
